import { useMemo } from "react";
import { IS_WHITE_LABEL } from "../constants";
import useOrg from "./apis/useOrg";

export const DEFAULT_TERMINOLOGY = {
  financeMenuLabel: "مالی",
  channelsMenuLabel: "کانال‌ها",
  accountMenuLabel: "حساب",
  marketplaceMenuLabel: "فروشگاه",
  productsMenuLabel: "محصولات",
  ordersMenuLabel: "سفارشات",
  logoutMenuLabel: "خروج",
  menuButtonLabel: "منو",
  withdrawButtonLabel: "برداشت",
};

export default function useOrgTerminology() {
  const { data: org } = useOrg();
  const isWhiteLabel = org?.config?.whiteLabel ?? IS_WHITE_LABEL;

  return useMemo(
    () => {
      if (!isWhiteLabel) return DEFAULT_TERMINOLOGY;
      const configured = org?.config?.terminology || {};
      return Object.fromEntries(
        Object.entries(DEFAULT_TERMINOLOGY).map(([key, fallback]) => {
          const value = configured[key as keyof typeof configured];
          return [key, value?.trim() || fallback];
        }),
      ) as typeof DEFAULT_TERMINOLOGY;
    },
    [isWhiteLabel, org?.config?.terminology],
  );
}
